import React, { useEffect } from 'react';
import ShapeButton from '@components/UI/ShapeButton';
import { useNotification } from '@hooks/useNotification';
import { useNavigate, useLocation } from 'react-router';
import styled from 'styled-components';

const MAX_DISPLAY_COUNT = 99;

const BellWrapper = styled.div`
  margin-right: 15px;
  position: relative;
  display: inline-flex;

  && .badge {
    top: -2px;
    right: -2px;
    height: 16px;
    min-width: 16px;
    line-height: 16px;
    padding: 0 4px;
    font-size: 10px;
    border-radius: 8px;
  }
`;

export default function NotificationWidget() {
  const { count, getNotifications } = useNotification();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/notification') {
      getNotifications();
    }
  }, [location.pathname, getNotifications]);

  const handleClick = () => {
    navigate('/notification');
  };

  const displayCount = count > MAX_DISPLAY_COUNT ? `${MAX_DISPLAY_COUNT}+` : count;

  return (
    <BellWrapper>
      <ShapeButton
        shape="square"
        label="Notification"
        handler={handleClick}
        icon="bell"
        badgeCount={displayCount}
        id="long-button"
        width="30px"
      />
    </BellWrapper>
  );
}
